import {
  Button,
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";

const EditBankDetail = ({ isOpen, onClose }) => {
  const [accountType, setAccountType] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
  };

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-gray-500/75 transition-opacity" />

      <div className="fixed inset-0 z-50 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-0 sm:p-4">
          <DialogPanel className="relative w-full transform overflow-hidden bg-white text-left shadow-xl transition-all rounded-xl max-w-[95vw] sm:max-w-md md:max-w-lg">
            <div className="bg-[#21140E0F] px-3 pb-6 pt-2 sm:px-6">
              <div className="flex justify-between items-center">
                <DialogTitle className="text-base sm:text-xl font-bold text-[#284184]">
                  Edit Fees
                </DialogTitle>
                <button
                  onClick={onClose}
                  className="text-[#1C2024] p-2 rounded-full transition-colors"
                >
                  <span className="text-4xl leading-none">&times;</span>
                </button>
              </div>
              <form onSubmit={handleSubmit} className="space-y-4">
                {/* Account Holder Name */}
                <div className="space-y-2">
                  <label htmlFor="accountHolder">
                    Account Holder Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="accountHolder"
                    placeholder="Enter Account Holder Name"
                    //   onChange={handleChange}
                    className="w-full rounded-md border border-gray-300 py-2 px-3 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-shadow"
                  />
                </div>

                {/* Account Type */}
                <div className="space-y-2">
                  <label htmlFor="accountType">
                    Account Type <span className="text-red-500">*</span>
                  </label>
                  <select
                    value={accountType}
                    onChange={(e) => setAccountType(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg p-2 text-sm sm:text-base focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="Savings Account">Savings Account</option>
                    <option value="Current Account">Current Account</option>
                  </select>
                </div>

                {/* Bank Name */}
                <div className="space-y-2">
                  <label htmlFor="bankName">
                    Bank Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="bankName"
                    placeholder="Enter Bank Name"
                    //   onChange={handleChange}
                    className="w-full rounded-md border border-gray-300 py-2 px-3 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-shadow"
                  />
                </div>

                {/* Transit Number */}
                <div className="space-y-2">
                  <label htmlFor="transitNumber">
                    Transit Number <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    name="transitNumber"
                    placeholder="Enter Transit Number"
                    //   onChange={handleChange}
                    className="w-full rounded-md border border-gray-300 py-2 px-3 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-shadow"
                  />
                </div>

                {/* Account Number */}
                <div className="space-y-2">
                  <label htmlFor="accountNumber">
                    Account Number <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    name="accountNumber"
                    placeholder="Enter Account Number"
                    //   onChange={handleChange}
                    className="w-full rounded-md border border-gray-300 py-2 px-3 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-shadow"
                  />
                </div>

                {/* Buttons */}
                <div className="flex gap-3 mt-6">
                  <button
                    type="button"
                    onClick={onClose}
                    className="w-full rounded-md border font-bold border-[#F04438] bg-white px-3 sm:px-4 py-2 text-sm text-[#F04438]"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="w-full rounded-md border font-bold border-transparent bg-[#284184] px-3 sm:px-4 py-2 text-sm text-white"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default EditBankDetail;
